import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps } from '@mui/material'
import styled from 'styled-components'

export type CheckboxPropsType = MuiCheckboxProps

const Checkbox = styled(MuiCheckbox)<CheckboxPropsType>``

export default Checkbox
